<template lang="pug">
.sell-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .d-flex.flex-column
      .sticky-top.bg-white
        .d-flex.px-4.py-4
          CustomerCompactDetailHeader(:data='customer')

          PanelTitleRight.ml-auto(
            title='รายการขาย'
            :subtitle='tableData ? `${totalRows} รายการ`:`...`'
            v-model='filterDate'
          )

        .d-flex.align-items-end.px-4.py-2
          CustomCategoriesFilter(
            title='เลือกดูรายการ'
            :items='statusList'
            v-model='filterStatus'
          )
          CustomSearchBox.ml-auto(
            v-model='filterSearch'
            type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
            :isLoading='isLoading'
          )

        //- for DEBUG
        //- .px-4.pt-2.mt-2
        //-   .alert.alert-warning.mb-0
        //-     template(v-if='filteredTableData') {{ filteredTableData.length }} items filtered
        //-     template(v-else) no available data

        hr.mb-0

      LoadedContentWrapper.flex-fill(
        :isLoading='isLoading'
        :data='tableData'
        @reload='loadData'
      )
        .py-2.px-3.flex-fill
          CustomTable(
            :columns='tableColumns'
            :data='filteredTableData'
            :showIndexes='true'
            :showNotificationDots='true'
            :startIndex='pageFirstRowIndex'
            @itemClicked='showModal'
          )

        .sticky-bottom.bg-white
          hr.m-0
          .px-4.py-3
            CustomPagination(
              v-model='currentPage'
              :total='totalPage'
            )

  modal(
    name='sell-record'
    width='90%' height='95%'
    transition='modal-transition'
  )
    template(v-if='customer && selectedItem')
      SellRecordDetail(
        :customer='customer'
        :sellRecord='selectedItem'
        @closeButtonClicked='hideModal'
      )

</template>

<script>
/* eslint-disable arrow-body-style */
import { mapGetters } from 'vuex';

import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    value: {},
  },
  watch: {
    customer() {
      this.loadData();
    },
    value() {
      // this.selectedItem = this.value;
      this.loadPreSelectedItemIfAny();
    },

    // reload data
    filterDate: {
      handler() { this.currentPage = 1; this.loadData(); },
      deep: true,
    },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    filterStatus() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     (
      //       !this.filterStatus
      //       || (item.status && item.status.toString() === this.filterStatus)
      //     )
      //     && (!KEYWORD || (item.entryNo && item.entryNo.toUpperCase().includes(KEYWORD)))
      //   );
      // });
      return this.tableData;
    },
  },
  data() {
    // const vue = this;
    return {
      isLoading: false,

      statusList: {
        pending: 'รออนุมัติ',
        submitted: 'อนุมัติ',
        cancelled: 'ไม่อนุมัติ',
      },
      filterStatus: '',

      filterDate: '',
      filterSearch: '',

      tableData: [],
      tableColumns: {
        entryNo: {
          title: 'เลขที่รายการ',
          align: 'left',
          type: 'EntryNo',
        },
        date: {
          title: 'วันที่ทำรายการ',
          align: 'left',
          type: Date,
        },
        time: {
          title: 'เวลา',
          align: 'left',
          type: this.$api.customer.COL_TYPE.Time,
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
          computed(row) {
            let total = 0;
            if (row.products) {
              for (let i = 0; i < row.products.length; i += 1) {
                const PROD = row.products[i];
                total += Number(PROD.price);
              }
            }
            return total;
          },
        },
        status: {
          title: 'สถานะ',
          align: 'center',
          type: this.$api.customer.COL_TYPE.OrderStatus,
        },
        shipmentStatus: {
          title: 'สถานะจัดส่ง',
          align: 'center',
          sortable: true,
          type: this.$api.customer.COL_TYPE.ShipmentStatus,
        },
      },

      // pagination
      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},
    };
  },
  mounted() {
    this.loadPreSelectedItemIfAny();
    this.loadData();
  },
  methods: {
    ...mapGetters({
      orderNotifications: 'orderNotifications',
    }),
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      // load data
      try {
        const res = await this.$api.customer.history.sell(
          this.customer.id,
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          this.filterStatus,
          this.filterSearch,
        );

        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
          // this.totalPage = 5;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('sell-record');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('sell-record');
      this.loadData();

      // emit
      this.$emit('input', '');
    },

    loadPreSelectedItemIfAny() {
      if (this.value) {
        this.showModal({ data: this.value });
      }
    },
  },
  components: {
    CustomerCompactDetailHeader,
    SellRecordDetail,
  },
};
</script>

<style lang="scss">
// .sell-list {}
</style>
